import { Box, Typography, Grid, Paper, Button, List, ListItem, ListItemIcon, ListItemText, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { keyframes } from '@mui/system';

const pop = keyframes`
  from { opacity:0; transform:scale(.95); }
  to   { opacity:1; transform:scale(1); }
`;

const plans = [
  { name: 'Starter', price: 'Gratuit', period: '', features: ['5 profils joueurs', '1 tournoi actif', 'Statistiques de base', 'Support communauté'], featured: false },
  { name: 'Pro', price: '15 000 GNF', period: '/mois', features: ['Joueurs illimités', '10 tournois actifs', 'Statistiques avancées', 'Analyse vidéo', 'Support prioritaire'], featured: true },
  { name: 'Club', price: '45 000 GNF', period: '/mois', features: ['Tout le plan Pro', 'Multi-équipes', 'API & exports', 'Manager dédié', 'Rapports personnalisés'], featured: false },
];

const Pricing = () => (
  <Box sx={{ py: 12, px: 3, bgcolor: '#ffffff' }}>
    <Typography variant="overline" sx={{
      letterSpacing: 4, display: 'block', textAlign: 'center', mb: 1,
      background: 'linear-gradient(135deg, #16a34a, #22c55e)',
      WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      fontWeight: 700,
    }}>
      Tarifs
    </Typography>
    <Typography variant="h2" sx={{ textAlign: 'center', color: '#0f172a', fontWeight: 800, mb: 8, fontSize: { xs: '2rem', md: '3rem' } }}>
      Choisissez votre plan
    </Typography>

    <Grid container spacing={3} maxWidth={1000} mx="auto" alignItems="center">
      {plans.map((p, i) => (
        <Grid item xs={12} md={4} key={i}>
          <Paper elevation={0} sx={{
            p: 4, textAlign: 'center', borderRadius: 4, position: 'relative',
            bgcolor: p.featured ? 'rgba(34,197,94,.05)' : '#f8fafc',
            border: `1px solid ${p.featured ? '#22c55e' : 'rgba(34,197,94,.15)'}`,
            transform: p.featured ? 'scale(1.05)' : 'scale(1)',
            boxShadow: p.featured ? '0 8px 40px rgba(34,197,94,.15)' : 'none',
            animation: `${pop} .7s ease forwards`, animationDelay: `${i * .15}s`, opacity: 0,
            transition: 'all .3s',
            '&:hover': {
              border: `1px solid ${p.featured ? '#16a34a' : 'rgba(34,197,94,.4)'}`,
              transform: p.featured ? 'scale(1.07)' : 'scale(1.02)',
              boxShadow: p.featured ? '0 12px 48px rgba(34,197,94,.2)' : '0 4px 20px rgba(34,197,94,.1)',
            },
          }}>
            {p.featured && (
              <Chip label="Populaire" sx={{
                position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                color: '#fff', fontWeight: 800,
                boxShadow: '0 4px 12px rgba(34,197,94,.35)',
              }} />
            )}
            <Typography variant="h6" sx={{
              fontWeight: 700, mb: 1,
              color: p.featured ? '#16a34a' : '#475569',
            }}>
              {p.name}
            </Typography>
            <Box sx={{ mb: 3 }}>
              <Typography component="span" sx={{ color: '#0f172a', fontWeight: 900, fontSize: '2rem' }}>{p.price}</Typography>
              <Typography component="span" sx={{ color: '#94a3b8', fontSize: '.9rem' }}>{p.period}</Typography>
            </Box>
            <List dense sx={{ mb: 3 }}>
              {p.features.map((f, j) => (
                <ListItem key={j} disableGutters>
                  <ListItemIcon sx={{ minWidth: 30 }}>
                    <CheckCircleIcon sx={{ fontSize: 16, color: '#22c55e' }} />
                  </ListItemIcon>
                  <ListItemText primary={f} primaryTypographyProps={{ sx: { color: '#64748b', fontSize: '.88rem' } }} />
                </ListItem>
              ))}
            </List>
            <Button fullWidth variant={p.featured ? 'contained' : 'outlined'} sx={{
              background: p.featured ? 'linear-gradient(135deg, #22c55e, #16a34a)' : 'transparent',
              color: p.featured ? '#fff' : '#16a34a',
              borderColor: 'rgba(34,197,94,.4)', borderWidth: '1.5px',
              fontWeight: 700, borderRadius: 2, py: 1.2,
              boxShadow: p.featured ? '0 4px 14px rgba(34,197,94,.3)' : 'none',
              '&:hover': {
                background: p.featured ? 'linear-gradient(135deg, #16a34a, #15803d)' : 'rgba(34,197,94,.06)',
                borderColor: '#22c55e', borderWidth: '1.5px',
                boxShadow: p.featured ? '0 6px 20px rgba(34,197,94,.35)' : 'none',
              },
            }}>
              Commencer
            </Button>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Pricing;